// frontend/src/pages/PreOrder_success.js
import Header from "../Header";
import Footer from "../Footer";
import { Link } from "react-router-dom";

const NAVY = "#1B2A4A";
const GOLD = "#EAA00A";
const GREEN = "#3AA655";

function PreOrder_success() {
  return (
    <div>
      <Header />

      <div style={{ background: "#F4F5F7", padding: "50px 16px" }}>
        <div
          style={{
            maxWidth: 560,
            margin: "0 auto",
            background: "#FCFCFA",
            borderRadius: 18,
            padding: "44px 36px 36px",
            textAlign: "center",
            boxShadow: "0 10px 40px rgba(0,0,0,.06)",
          }}
        >
          {/* ===== Check icon ===== */}
          <div
            style={{
              width: 92,
              height: 92,
              borderRadius: "50%",
              border: `4px solid ${GREEN}`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 24px",
            }}
          >
            <i className="bi bi-check-lg" style={{ fontSize: 46, color: GREEN }}></i>
          </div>

          {/* ===== Title ===== */}
          <h1 style={{ color: NAVY, fontWeight: 800, fontSize: 30, marginTop: '-10px' }}>
            Order Confirmed!
          </h1>

          <p style={{ color: "#3A3A3A", fontSize: 19, fontWeight: 200, marginTop: '-3px', marginBottom: 2 }}>
            Thank you for your purchase of
          </p>
          <p style={{ color: GOLD, fontWeight: 700, fontStyle: "italic", fontSize: 24, marginTop: 0 }}>
            Persist, Persist, Persist!
          </p>

          {/* ===== Divider with star ===== */}
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginTop: '-20px' }}>
            <span style={{ flex: 1, height: 1, background: GOLD, maxWidth: 140 }}></span>
            <i className="bi bi-star-fill" style={{ color: GOLD, margin: "0 14px", fontSize: 16 }}></i>
            <span style={{ flex: 1, height: 1, background: GOLD, maxWidth: 140 }}></span>
          </div>

          {/* ===== Info rows ===== */}
          <InfoRow icon="bi-box-seam-fill">
            Your order has been received and will be shipped soon.
          </InfoRow>

          <InfoRow icon="bi-truck">
            Please allow up to <strong style={{ color: GOLD }}>7 business days</strong> for delivery.
          </InfoRow>

          <InfoRow icon="bi-envelope-fill">
            Questions? Reach out to our team at{" "}
            <strong style={{ color: NAVY }}>junior@persist.com</strong>.
          </InfoRow>

          <InfoRow icon="bi-heart-fill" last>
            Thank you for your support, and enjoy the journey!
          </InfoRow>

          {/* ===== Gift box ===== */}
          <div
            style={{
              marginTop: 28,
              border: `1.5px solid ${GOLD}`,
              borderRadius: 12,
              background: "#FBF3E7",
              padding: "12px 16px",
              display: "flex",
              alignItems: "center",
              gap: 12,
              textAlign: "left",
            }}
          >
            <i className="bi bi-gift-fill" style={{ fontSize: 24, color: GOLD, flexShrink: 0 }}></i>
            <div>
              <div style={{ color: NAVY, fontWeight: 700, fontSize: 13, lineHeight: 1.3, marginBottom: '-5px'  }}>
                Do you know someone else who would benefit from the story?
              </div>
              <a
                href="/BuyPhysicalBook"
                style={{ color: GOLD, fontWeight: 700, fontSize: 13, textDecoration: "none" }}
              >
                Gift them a copy!
              </a>
            </div>
          </div>

          {/* ===== Footer signature ===== */}
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginTop: 30 }}>
            <span style={{ flex: 1, height: 1, background: "#d9d9d9", maxWidth: 80 }}></span>
            <span style={{ margin: "0 14px", color: NAVY, fontStyle: "italic", fontSize: 17 }}>
              Team Persist
            </span>
            <span style={{ flex: 1, height: 1, background: "#d9d9d9", maxWidth: 80 }}></span>
          </div>
        </div>
      </div>

      {/* <div className="mt-5">
        <div className="buy_por984774_text1 mt-3">SHOP THE PERSIST COLLECTION</div>
        <div className="buy_por984774_text2">LET'S SPREAD A POSITIVE VIBE TOGETHER!</div>
        <div className="mt-4">
          <center>
            <a className="buy_box_btn px-5" target="_blank" href="https://ayisyenkapab.com/persist-collection/" rel="noreferrer">SHOP NOW</a>
          </center>
          <img className="w-100 mt-3" src={'/images/new/pub_img1.png'} alt="" />
        </div>
      </div> */}

      <Footer />
    </div>
  )
}

function InfoRow({ icon, children, last }) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 18,
        textAlign: "left",
        padding: "8px 4px",
        borderBottom: last ? "none" : "1px solid #ECECEC",
      }}
    >
      <div
        style={{
          width: 32,
          height: 32,
          borderRadius: "50%",
          background: NAVY,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
        }}
      >
        <i className={`bi ${icon}`} style={{ color: "#fff", fontSize: 12 }}></i>
      </div>
      <div style={{ color: "#2E2E2E", fontSize: 17, fontWeight: 200, lineHeight: 1.4 }}>{children}</div>
    </div>
  );
}

export default PreOrder_success
